import {useEffect, useState} from "react";
import {Link, useNavigate, useParams} from "react-router-dom";
import {BreadCrumbs} from "../../../components/open/pages";
import {AuthRedirectAdmins, AuthRedirectParents, PostJSON} from "../../../components/api/webservice";
import {Apis} from "../../../components/api/url";
import {HideProgressLoading} from "../../../components/template/architecture";
import {ShowConnectionFailed} from "../../../components/template/connection-failed";
import {ShowSnackbar} from "../../../components/template/snackbar";
import {CurrencyFormat, StringDigitsConvertToPersian} from "../../../components/techaran/money";
import {CheckIcon, TomansIcon} from "../../../components/icons/material-icons";
import {GregorianToPersian} from "../../../components/techaran/date-convert";

export const AdminsStudentsTuitionPaidInvoiceScreen = () => {
    const {invoiceId} = useParams();
    let navigate = useNavigate();
    const [data, setData] = useState({
        loaded: false,
        price: 0,
        paidAt: '2000-01-01 00:00:00',
        studentId:0,
    });
    const fetchData = () => {
        PostJSON(
            Apis.server + '/core/admins/students/tuition/invoice/get-paid',
            {n: invoiceId as string},
            true,
            (d: {
                result: string,
                reason: string | undefined,
                price: number,
                paidAt: string,
                studentId:number,
            }) => {
                HideProgressLoading();
                if (d.result !== 'OK') {
                    if (d.reason === 'login')
                        AuthRedirectParents();
                    else if (d.reason === 'not-found') {
                        ShowSnackbar('فاکتور موردنظر یافت نشد.', 'باشه', 5000);
                        navigate('/admins/overview', {replace: true});
                    }
                    return;
                }
                setData({
                    loaded: true,
                    paidAt: d.paidAt,
                    price: d.price,
                    studentId: d.studentId,
                });
            },
            () => {
                HideProgressLoading();
                ShowConnectionFailed('fa');
            },
            AuthRedirectAdmins,
        ).then(void 0);
    };
    useEffect(() => {
        document.title = "فاکتور شهریه | نهال";
        fetchData();
    }, []);
    return (
        <>
            <BreadCrumbs links={[
                {title: 'داشبورد', url: '/admins/'},
                {title: 'امور مالی', url: '/admins/finance'},
                {title: 'فاکتور شهریه', url: `/admins/finance/invoice-paid/${invoiceId}`},
            ]}/>
            {
                data.loaded ?
                    <div className="container" data-aos="fade-up" data-aos-duration={1000}>
                        <div className="row justify-content-center">
                            <div className="col-lg-6">
                                <div className="screen-card">
                                    <div className="screen-card-header">
                                        <b>فاکتور شهریه</b>
                                    </div>
                                    <div className="tuition-invoice-checkmark">
                                        <i><CheckIcon/></i>
                                        <b>پرداخت موفق</b>
                                    </div>
                                    <div style={{height: 30}}/>
                                    <div className="info-tile">
                                        <b>شماره فاکتور:</b>
                                        <span>{StringDigitsConvertToPersian(invoiceId as string)}</span>
                                    </div>
                                    <div className="info-tile">
                                        <b>مبلغ فاکتور:</b>
                                        <span>
                                            {StringDigitsConvertToPersian(CurrencyFormat(data.price))}
                                            <TomansIcon/>
                                        </span>
                                    </div>
                                    <div className="info-tile">
                                        <b>موضوع فاکتور:</b>
                                        <span>پرداخت شهریه</span>
                                    </div>
                                    <div className="info-tile">
                                        <b>تاریخ پرداخت:</b>
                                        <span>{StringDigitsConvertToPersian(GregorianToPersian(data.paidAt.split(' ')[0]).replaceAll('-', '/'))}</span>
                                    </div>
                                    <div className="info-tile">
                                        <b>نحوه پرداخت:</b>
                                        <span>پرداخت آنلاین</span>
                                    </div>
                                    <div style={{height: 30}}/>
                                    <div className="d-flex justify-content-end align-items-center">
                                        <Link to={`/admins/students/view/${data.studentId}`} className="cancel-button">
                                            <b>بازگشت</b>
                                        </Link>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div> : null
            }
        </>
    );
};